import { View, XStack, Image, YStack, Label } from "tamagui";
import { useEffect, useState, useRef } from "react";
import { Calendar } from "@tamagui/lucide-icons-2";
import { getImageColorStyle } from "@my/util";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
const XPDatePicker = props => {
  const old = /* @__PURE__ */jsx(Fragment, {});
  const newImpl = /* @__PURE__ */jsx(WebNativeDatePicker, {
    value: props.value,
    onChange: props.onChange,
    name: props.name,
    placeHolder: props.placeHolder,
    minDate: props.minDate,
    maxDate: props.maxDate,
    icon: props.icon,
    showIcon: props.showIcon,
    tintColor: props.tintColor,
    color: props.color,
    fullDate: props.fullDate
  });
  return /* @__PURE__ */jsx(View, {
    mt: 10,
    children: props.webNative ? newImpl : old
  });
};
function WebNativeDatePicker(props) {
  const inputRef = useRef(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(false);
  }, [props.value]);
  const onDateChange = dates => {
    const selectedDate = dates?.[0];
    if (selectedDate) {
      let dateToUse = selectedDate;
      if (props.minDate && props.maxDate) {
        if (selectedDate < props.minDate) {
          dateToUse = props.minDate;
        }
      }
      const isoString = dateToUse.toISOString();
      props.onChange(isoString);
    } else {
      props.onChange("");
    }
  };
  const formatDisplayDate = dateStr => {
    return (dateStr && typeof dateStr === "string" ? dateStr : "").split("T")[0];
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const handleButtonClick = () => {
    if (inputRef.current) {
      try {
        inputRef.current.focus();
        inputRef.current.showPicker();
      } catch (error) {
        inputRef.current.click();
      }
    }
  };
  const config = {
    selectedDates: props.value ? [new Date(props.value)] : [],
    onDatesChange: onDateChange,
    calendar: {
      startDay: 0
    },
    dates: {
      mode: "single",
      minDate: props?.minDate,
      maxDate: props?.maxDate
    }
  };
  const handleChange = event => {
    const value = event.target.value;
    props.onChange(value);
  };
  const label = props?.label !== void 0 ? props.label : props.placeHolder || "";
  const newPicker = /* @__PURE__ */jsxs(YStack, {
    children: [label ? /* @__PURE__ */jsx(Label, {
      children: label
    }) : null, /* @__PURE__ */jsxs(XStack, {
      style: {
        width: "100%",
        minHeight: 45,
        //height: '100%',
        alignItems: "stretch",
        //border: '2px solid rgb(233, 236, 239)',
        borderRadius: 4
      },
      children: [props.showIcon ? /* @__PURE__ */jsx(XStack, {
        style: {
          alignItems: "center",
          //marginLeft: 10,
          marginRight: 10,
          cursor: "pointer"
        },
        onPress: handleButtonClick,
        children: props.icon ? /* @__PURE__ */jsx(Image, {
          src: props.icon,
          style: {
            height: 15,
            maxWidth: 20,
            ...getImageColorStyle(props.tintColor)
          },
          height: 15,
          tintColor: props.tintColor,
          resizeMode: "contain"
        }) : /* @__PURE__ */jsx(Calendar, {})
      }) : null, /* @__PURE__ */jsxs(XStack, {
        style: {
          //maxWidth: '91.5%',
          flex: 1,
          height: 45,
          borderWidth: 1,
          borderColor: "rgb(224, 225, 230)",
          backgroundColor: "rgba(240, 241, 244, .75)",
          borderRadius: 9,
          alignItems: "center"
        },
        hoverStyle: {
          backgroundColor: "rgba(240, 241, 244, .5)"
        },
        onPress: handleButtonClick,
        children: [/* @__PURE__ */jsx(XStack, {
          style: {
            //width: '100%',
            height: "100%",
            cursor: "pointer"
            //flex: 1
            //borderBottom: '2px solid rgb(133, 193, 157)'
          },
          children: /* @__PURE__ */jsx("input", {
            ref: inputRef,
            type: "date",
            value: formatDisplayDate(props.value),
            name: props.name,
            onChange: handleChange,
            style: {
              //width: '85%',
              flex: 1,
              height: "100%",
              cursor: "text"
            }
          })
        }), /* @__PURE__ */jsx(XStack, {
          style: {
            width: "100%",
            height: "100%",
            cursor: "pointer"
            //borderBottom: '2px solid rgb(133, 193, 157)'
          },
          children: "\u200B"
        })]
      })]
    })]
  });
  return newPicker;
}
export { WebNativeDatePicker, XPDatePicker };
//# sourceMappingURL=DatePicker.mjs.map
